import { registerComponent } from '@gig/magic-common';
import TagEnhancedComponent from './tag-enhanced.vue.js';

var TagEnhanced = registerComponent(TagEnhancedComponent);

export { TagEnhanced };
